import { ConfirmModal, Select } from 'shared/components'
import { defaultConfig } from 'config/default'
import { IOption } from 'interfaces/select.interface'
import { useTranslation } from 'libs/i18n'

type FormatModalProps = {
	isOpened: boolean
	disableButton: boolean
	isLoading?: boolean
	closeModal: () => void
	confirm: () => void
	onChange: (data: IOption) => void
}

export const FormatModal = ({
	isOpened,
	closeModal,
	confirm,
	isLoading,
	disableButton,
	onChange
}: FormatModalProps) => {
	const { t } = useTranslation()

	return (
		<ConfirmModal
			isOpened={isOpened}
			title={t('Export format')}
			confirmText={t('Download')}
			isLoading={isLoading}
			disabled={disableButton}
			closeModal={closeModal}
			confirm={confirm}>
			<Select
				id="exportFormat"
				variant="form"
				label={t('Select format')}
				options={defaultConfig.exportFormatOptions}
				menuPortalTarget={document.body}
				menuPosition="fixed"
				onChange={onChange}
			/>
		</ConfirmModal>
	)
}
